import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Box, Button, Container } from "@material-ui/core";
import { ChevronLeftOutlined } from "@material-ui/icons";
import LeftPanel from "Modules/Checkins/Overview/LeftPanel";
import RightPanel from "Modules/Checkins/Overview/RightPanel";
import SkillRatingPanel from "Modules/Checkins/Overview/SkillRatingPanel";
import { useCheckin } from "Hooks/checkin/useCheckin";
import PageHeader from "Components/PageHeader";
import { OVERVIEW, TARGET } from "Constants/routeConstants";
import { useStyles } from "./styles";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { checkinDetailSelector } from "Recoil/Checkins/selector";
import { LoadingWidget } from "Components/index";
import {
  authPageState,
  checkinDetailsExpandState,
  surveyResponseState,
} from "Recoil/Checkins/atom";
import ErrorPage from "Components/widgets/ErrorPage";
import { updateOrangeDotStatus } from "GraphQL/mutation/targetReview";
import { useMutation } from "@apollo/client";

const CheckinOverview = () => {
  const history = useHistory();
  const classes = useStyles();
  const [skillRatee, setSkillRatee] = useState({});
  const [selectedSkillName, setSelectedSkillName] = useState();
  const [sortSelected, setSortSelected] = useState("Group by people");
  const [selectedFrequency, setSelectedFrequency] = useState(null);
  const [authPage, setAuthPage] = useRecoilState(authPageState);
  const { id: targetId, checkinId } = useParams();
  const setExpand = useSetRecoilState(checkinDetailsExpandState);
  const [updateOrangeDotRatingStatus] = useMutation(updateOrangeDotStatus);
  const { getCheckinOverview, checkinOverviewLoader } = useCheckin();
  const checkinDetail = useRecoilValue(checkinDetailSelector);
  const { checkInType } = checkinDetail;
  const [surveyResponseData, setSurveyResponseData] =
    useRecoilState(surveyResponseState);

  useEffect(() => {
    setAuthPage(false);
    getCheckinOverview({ variables: { id: checkinId } });
    return () => {
      if (
        checkinId &&
        checkinDetail?.checkInType &&
        checkinDetail?.checkInType !== "LEARNING"
      ) {
        handleOrangeDot();
      }
    };
  }, [checkinId, checkInType]);

  useEffect(() => {
    return () => {
      if (surveyResponseData?.length) {
        handleOrangeDot(surveyResponseData);
      }
    };
  }, [surveyResponseData?.length]);

  useEffect(() => {
    return () => {
      setExpand(false);
    };
  }, []);

  const handleOrangeDot = (surveyResponseData = []) => {
    const userIds = [];
    surveyResponseData?.forEach((item) => {
      if (item?.isNewRowHighlight) {
        userIds.push(item.id);
      }
    });
    updateOrangeDotRatingStatus({
      variables: {
        input: {
          targetid: targetId,
          checkinId: [checkinId],
          checkinType: checkInType ? checkInType.toLowerCase() : null,
          userid: userIds?.length ? userIds : null,
          isNewHighlighted: false,
        },
      },
    });
  };

  if (checkinOverviewLoader) {
    return <LoadingWidget pageLoader={true} />;
  }

  return (
    <main className={classes.content}>
      {authPage ? (
        <ErrorPage errorCode="403" />
      ) : (
        <Box flexGrow={1}>
          <PageHeader containerWidth="lg" title="Check-in Details">
            <Box display="flex">
              <Button
                color="primary"
                className="font-semibold"
                data-testid="back-btn"
                onClick={() => {
                  history.push({
                    pathname: `${TARGET}${OVERVIEW}/${targetId}`,
                    state: { currentTab: "checkin" }
                  });
                }}
              >
                <ChevronLeftOutlined />
                Back to target details
              </Button>
            </Box>
          </PageHeader>
          <Container maxWidth="lg">
            <div className={classes.pageContent}>
              <Box className={classes.mainContent}>
                <LeftPanel
                  skillRatee={skillRatee}
                  setSkillRatee={setSkillRatee}
                  sortSelected={sortSelected}
                  setSortSelected={setSortSelected}
                  selectedSkillName={selectedSkillName}
                  setSelectedSkillName={setSelectedSkillName}
                  selectedFrequency={selectedFrequency}
                  setSelectedFrequency={setSelectedFrequency}
                  checkinId={checkinId}
                />
                {checkInType === "SKILLRATING" ? (
                  <SkillRatingPanel
                    skillRatee={skillRatee}
                    setSkillRatee={setSkillRatee}
                    selectedSkillName={selectedSkillName}
                    setSelectedSkillName={setSelectedSkillName}
                    selectedFrequency={selectedFrequency}
                    setSelectedFrequency={setSelectedFrequency}
                  />
                ) : (
                  <RightPanel
                    sortSelected={sortSelected}
                    setSortSelected={setSortSelected}
                    selectedFrequency={selectedFrequency}
                  />
                )}
              </Box>
            </div>
          </Container>
        </Box>
      )}
    </main>
  );
};

export default CheckinOverview;